<template>
  <div class="home-wrap">
    <div class="padding-11-15 padding-b-0">
      <div class="title-text-official padding-b-19">推广订单</div>
      <div class="search-wrap">
        <div class="search-form">
          <div class="search-item search-input-item">
            <Select v-model="searchForm.state"  placeholder="全部状态">
              <Option v-for="item in status_list" :value="item.value" :key="item.value">{{ item.label }}</Option>
            </Select>
          </div>
          <div class="search-item search-input-item">
            <input type="text" class="search-input"  v-model="searchForm.nickName" placeholder="会员昵称"/>
          </div>
          <div class="search-item search-input-item">
            <input type="text" class="search-input"   v-model="searchForm.orderNo" placeholder="订单编号"/>
          </div>
          <div class="search-item search-input-item">
            <input type="text" class="search-input"   v-model="searchForm.sourceId" placeholder="会员ID"/>
          </div>
          <div class="search-item search-input-item search-box">
            <input type="text" class="search-input"   v-model="searchForm.commissionMix" placeholder="最小佣金值"/>
            <span>至</span>
            <input type="text" class="search-input"   v-model="searchForm.commissionMax" placeholder="最大佣金值"/>
          </div>
          <div class="search-item search-input-item search-box date-picker">
            <el-col :span="11">
              <el-input v-model="searchForm.start_time_bak" @blur.native @focus="showDatePicker('start_time_bak')" placeholder="下单日期" suffix-icon="el-icon-times" readonly></el-input>
              <img class="clear-icon" v-show="searchForm.start_time_bak" src="../../../../assets/img/login_btn_cancel.png" alt="" @click="clear('searchForm.start_time_bak')">
            </el-col>
            <el-col :span="2" class="date-range">至</el-col>
            <el-col :span="11">
              <el-input v-model="searchForm.end_time_bak" @blur.native @focus="showDatePicker('end_time_bak')" placeholder="下单日期" suffix-icon="el-icon-times" readonly></el-input>
              <img class="clear-icon" v-show="searchForm.end_time_bak" src="../../../../assets/img/login_btn_cancel.png" alt="" @click="clear('searchForm.end_time_bak')">
            </el-col>
          </div>
        </div>
        <div class="btn-wrap">
          <div class="search-btn" @click="handleFilter">查询</div>
          <div class="search-btn" @click="handleOrderExport">导出报表</div>
        </div>
      </div>
    </div>
    <div class="gray"></div>
    <div class="padding-0-15 padding-b-8">
      <div class="title-text-official padding-11-0 padding-b-19">影票列表</div>
      <div class="table-wrapper">
        <el-table :data="list" border style="width: 100%">
          <el-table-column prop="date" label="影票信息" width="100" align="left" header-align="center">
            <template slot-scope="{row}">
              <div class="movie-info">
                <div class="movie-name" @click="showDetail(row)"><span class="font-11">{{ row.movieName }}</span></div>
                <div><span class="font-11">{{ row.ticketNum }}</span></div>
              </div>
              <img :src="row.movieImage" class="movie-image"/>
            </template>
          </el-table-column>
          <el-table-column prop="date" label="订单编号" width="150" align="left" header-align="center">
            <template slot-scope="{row}">
              <span>{{ row.orderNo }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="date" label="下单会员" width="80" align="center">
            <template slot-scope="{row}">
              <span>{{ row.nickName }}({{ row.sourceId }})</span>
            </template>
          </el-table-column>
          <el-table-column prop="date" label="下单时间" width="90" align="center">
            <template slot-scope="{row}">
              <span>{{ row.createTime }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="date" label="订单总佣金" width="90" align="center">
            <template slot-scope="{row}">
              <span class="commission" @click="showCommissionDetail(row)">{{ row.commissionTotal }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="date" label="订单状态" width="80" align="center">
            <template slot-scope="{row}">
              <span v-if="row.state == 6">待出票</span>
              <span v-if="row.state == 8">已出票</span>
              <span v-if="row.state == 9">已读票</span>
              <span v-if="row.state == 10">未结算</span>
              <span v-if="row.state == 20">已结算</span>
              <span v-if="row.state == 15">订单失效</span>
            </template>
          </el-table-column>
          <el-table-column prop="date" label="结算时间" width="90" align="center">
            <template slot-scope="{row}">
              <span>{{ row.settleTime }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="date" label="操作" width="80" fixed="right" align="center">
            <template slot-scope="{row}">
              <span class="color-ff4" style="cursor: pointer" @click="showDetail(row)">查看详情</span>
            </template>
          </el-table-column>
        </el-table>
        <pagination v-show="total>0" :total="total" :page.sync="searchForm.pageNo" :limit.sync="searchForm.pageSize" @pagination="getList(false)" />
      </div>
    </div>
    <detail ref='detail'></detail>
    <commission-detail ref='commissionDetail'></commission-detail>
    <DatePicker ref="DatePicker" :title="curDateTitle" @selectedDate="selectedDate"></DatePicker>
  </div>
</template>

<script>
import { getPlatformUuid, getToken,  getUserUUID} from '@/utils/auth'
import DatePicker from '@/components/h5/DatePicker'
import Pagination from '@/components/h5/Pagination' // secondary package based on el-pagination
import {  Select, Option } from 'view-design'
//import { getOrderList } from '@/api/order'
import Detail from  '@/views/h5/official/order/modal/TicketDetail.vue'
import CommissionDetail from '@/views/h5/official/order/modal/CommissionDetail.vue'
import { getDate, numFormatter } from '@/utils/date'
import order from '@/javaApi/order'
const orderModel = new order()
export default {
  name: 'Order',
  components: {
    Pagination,
    Select,
    Option,
    DatePicker,
    Detail,
    CommissionDetail
  },
  data: function () {
    return {
      listLoading: false,
      status_list:[
        {"label":"全部","value":""},
        {"label":"待出票","value":"6"},
        {"label":"已出票","value":"8"},
        {"label":"已读票","value":"9"},
        {"label":"已结算","value":"20"},
        {"label":"订单失效","value":"15"},
      ],
      list:[],
      total:0,
      platformUuid: getPlatformUuid(),
      searchForm: {
        pageNo: 1,
        pageSize: 10,
        state: undefined,
        phone: undefined,
        nickName: undefined,
        orderNo: undefined,
        sourceId: undefined,
        commissionMix: undefined,
        commissionMax: undefined,
        start_time_bak: undefined,
        end_time_bak: undefined,
        createStartTime: undefined,
        createEndTime: undefined,
        platformUuid: undefined,
        userUuid:undefined
      },
      curDateTitle: '',// 日期选择器弹窗标题
      datePicker: '', // 用于判断哪个选择器
    }
  },
  created() {
    let param = this.$route.query
    if(param.user_id){
      this.searchForm.userUuid = param.user_id
    }
    if(param.nick_name){
      this.searchForm.nickName = param.nick_name
    }
    this.getList(true)
  },
  methods: {
    getList(first = false){
      this.listLoading = true
      if(first) this.searchForm.pageNo = 1
      let searchForm = Object.assign({}, this.searchForm)
      // 如果查询的参数为空直接unset 掉
      searchForm = this.formateInit(searchForm)
      let condition = (this.platformUuid == '' || this.platformUuid == 0);
      if(!condition){
        searchForm.platformUuid =  this.platformUuid
      }
      let createTimeStartStr = getDate(searchForm.start_time_bak)
      if(createTimeStartStr){
        searchForm.createStartTime = createTimeStartStr+' 00:00:00'
      }else{
        delete  searchForm.createStartTime
      }
      let createTimeEndStr = getDate(searchForm.end_time_bak)
      if(createTimeEndStr){
        searchForm.createEndTime = createTimeEndStr+' 23:59:59'
      }else{
        delete  searchForm.createEndTime
      }

      delete searchForm.start_time_bak
      delete searchForm.end_time_bak
      if(searchForm.sourceId){
        searchForm.sourceId = numFormatter(searchForm.sourceId)
      }
      orderModel.getOrderList(searchForm).then((response) => {
        var res = response.data
        this.listLoading = false
        if(res.code != 200){
          this.$Message.error(res.message)
          return
        }
        this.list = res.data.list
        this.total = res.data.total
        // 处理影票信息
        for(let i in this.list){
          let row = this.list[i]
          let movieInfo = row.movieInfo;
          if(movieInfo !== ''){
            movieInfo = JSON.parse(movieInfo)
          }
          this.list[i].movieName = movieInfo[5]
          this.list[i].movieImage = movieInfo[6]
          this.list[i].ticketNum = row.number + '张'
        }
      })
    },
    formateData(data){
      if(!data){
        return []
      }
      if(!data.length){
        return []
      }
      let i = 0;
      let pageNo = this.searchForm.pageNo
      let pageSize = this.searchForm.pageSize
      for(i=0;i<data.length;i++){
        data[i].sequence = (i+1)+(pageNo - 1)*pageSize
      }
      return  data
    },
    formateInit(formData){
      let objCopy = {};
      for(let key in formData){
        if(formData[key]){
          objCopy[key] = formData[key];
        }
      }
      return objCopy;
    },
    handleFilter(){
      this.getList(true)
    },
    //订单导出
    handleOrderExport() {
      this.listLoading = true
      let searchForm = Object.assign({}, this.searchForm)
      // 如果查询的参数为空直接unset 掉
      searchForm = this.formateInit(searchForm)
      let condition = (this.platformUuid == '' || this.platformUuid == 0);
      if(!condition){
        searchForm.platformUuid =  this.platformUuid
      }
      let createTimeStartStr = getDate(searchForm.start_time_bak)
      if(createTimeStartStr){
        searchForm.createStartTime = createTimeStartStr+' 00:00:00'
      }else{
        delete  searchForm.createStartTime
      }
      let createTimeEndStr = getDate(searchForm.end_time_bak)
      if(createTimeEndStr){
        searchForm.createEndTime = createTimeEndStr+' 23:59:59'
      }else{
        delete  searchForm.createEndTime
      }

      delete searchForm.start_time_bak
      delete searchForm.end_time_bak
      delete searchForm.pageNo
      delete searchForm.pageSize
      this.$Message.success('正在下载...')
      searchForm.xToken = getToken()
      searchForm.uuid = getUserUUID()
      searchForm = this.formateInit(searchForm)
      orderModel.exportOrder(searchForm).then(async (res) => {
        this.listLoading = false
        const message = res.data.info || res.data.message
        const code = res.data.code
        if(code === 200){
          await this.$dialog( {
            title:'导出数据提示',
            message:'当前数据下载中，请前往 导出中心 查看',
            showCancelButton: true,
            confirmButtonText: '前往导出列表',
            cancelButtonText: '取消',
            callback: action => {
              if(action === 'confirm'){
                this.$router.push({ path: "/h5/exportCenter/index" });
              }
            }
          });
        }else{
          this.$Message.error(message);
        }
      })
    },
    formatDate(date) {
      var y = date.getFullYear();
      var m = date.getMonth() + 1;
      m = m < 10 ? '0' + m : m;
      var d = date.getDate();
      d = d < 10 ? ('0' + d) : d;
      return y + m + d;
    },
    changePage(value){
      this.searchForm.pageNo = value
      this.getList()
    },
    changePagesize(value){
      this.searchForm.pageSize = value;
      //如果处于第一页改变数量，则会触发changePage
      if(this.searchForm.pageNo == 1){
        this.getList()
      }
    },
    showDetail (row) {
      this.$refs.detail.init(row)
    },
    // 佣金详情
    showCommissionDetail (row) {
      this.$refs.commissionDetail.init(row)
    },
    showDatePicker(datePicker){
      let title = '请选择开始日期';
      if(datePicker.toUpperCase().indexOf('END') > -1){
        title = '请选择结束日期';
      }
      this.curDateTitle = title
      this.datePicker = datePicker
      this.$refs.DatePicker.init();
    },
    selectedDate(timer){
      this.searchForm[this.datePicker] = timer;
    },
    //清除文本框
    clear(val) {
      if(val.indexOf(".") > -1){
        let varArr = val.split(".")
        this[varArr[0]][varArr[1]] = ''
      }else{
        this[val] = ''
      }
    },
  }
}
</script>

<style lang="less" scoped>
.home-wrap{
  font-family: Alibaba-PuHuiTi-R;
  .btn-wrap{
    display: flex;
    justify-content: space-around;
    .search-btn{
      width: 40%;
    }
  }
  .table-wrapper {
    width: 100%;
    .color-ff4{
      white-space: nowrap;
    }
    .movie-info{
      display: flex;
      margin-bottom: 8px;
      color: #333333;
      line-height: 15px;
      .movie-name{
        margin-right: 8px;
        color: #3A94F2;
        cursor: pointer;
      }
    }
    .movie-image{
      width: 44px;
    }
    .commission{
      color: #3A94F2;
      cursor: pointer;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/h5/official/order/index.vue